// extracted by mini-css-extract-plugin
export default {"zr-table":"OrderList_zr-table__+Z04F","table-header":"OrderList_table-header__RG6gw"};